$(document).ready(function() {
  let selectedColor;
  let selectedType;
  let selectedMinPrice = 0;
  let selectedMaxPrice = 2000;
  let cbCharmSliderPrice;
  var mobileHTMLGenerated = false;
  $(document).on('click', '.mob-filter', function() {
    $('.filter-card-left').addClass('open-mob-filter');
  });
  $(document).on('click', '.close-mob-filter', function() {
    $('.filter-card-left').removeClass('open-mob-filter');
  });
  // Event listener for sort toggle button
  $("#price-filter-btn").on("click", function(event) {
    event.stopPropagation();
    $("#listOptionCard").toggle();
    $(".list-option-label").toggleClass("list-option-label-down");
  });
  // Hide the list-option-card when clicking anywhere else on the document
  $(document).on("click", function() {
    $("#listOptionCard").hide();
    $(".list-option-label").removeClass("list-option-label-down");
  });
  // Prevent the card itself from closing when clicked inside
  $("#listOptionCard").on("click", function(event) {
    event.stopPropagation();
    $(".list-option-label").removeClass("list-option-label-down");
  });
  // Log option value and hide card
  function logOptionValueAndHideCard() {
    $(".list-option").on("click", function() {
      const selectedSortValue = $(this).data("type");
      if (selectedSortValue) {
        getVariantsColor(allProducts, selectedColor, selectedType, selectedSortValue);
      }
      $(".list-option-card").hide();
    });
  }
  // Setup event listeners for color options
  function setupColorOptions() {
    $(".color-option").on("click", function() {
      $(".color-option").removeClass("selected");
      $(this).addClass("selected");
      selectedColor = $(this).data("color").toLowerCase();
      if (selectedColor.includes("white gold") || selectedColor.includes("silver")) {
        selectedColor = "white gold / silver";
      }
      getVariantsColor(allProducts, selectedColor, selectedType);
    });
  }
  // Setup event listeners for product type options
  function setupProductTypeOptions() {
    $(".product-type").on("click", function() {
      $(".product-type").removeClass("selected");
      $(this).addClass("selected");
      selectedType = $(this).data("type");
      getVariantsColor(allProducts, selectedColor, selectedType);
    });
  }
  // Load initial selections for color and product type
  function loadInitialSelections() {
    const firstColorOption = $(".color-option").first();
    firstColorOption.addClass("selected");
    selectedColor = firstColorOption.data("color");
    const firstProductTypeOption = $(".product-type").first();
    firstProductTypeOption.addClass("selected");
    selectedType = firstProductTypeOption.data("type");
  }
  // Get unique prices from product variants
  function getUniquePrices(variants) {
    return [...new Set(variants.map(v => v.price))];
  }
  // Filter images based on alt text containing the selected color
  function filterImagesByColor(media, colors) {
    if (!media || !colors || colors.length === 0) return [];
    const normalizedColors = colors.map(color => color.toLowerCase().trim());
    const filteredImagesByColor = {};
    normalizedColors.forEach(color => {
      const filteredImages = media.filter(image => {
        const normalizedAlt = (image.alt || "").toLowerCase().trim();
        return normalizedAlt.includes(color);
      }).slice(0, 2);
      filteredImagesByColor[color] = filteredImages;
    });
    return Object.values(filteredImagesByColor).flat();
  }
  // Generate HTML for product card (desktop)
  function generateDesktopProductCardHTML(item) {
    var VariantMetaID = item.variantmetafield
    var VariantJSon = item.variant
    var variantID = item.variant.id;
    var productID = item.productId;
    var variantSKU = item.variant.sku;
    var prodVariants = item.product;
    var smallest_variant_id = prodVariants[0].id;
    var smallest_variant_price = prodVariants[0].price;
    for (let i = 0; i < prodVariants.length; i++) {
      var IndivVariant = prodVariants[i];
      if (IndivVariant.inventory_quantity > 0 && IndivVariant.inventory_management != null && IndivVariant.option2 != "I don't know my size; send me a Ring Sizing Gauge!") {
        if (IndivVariant.price <= smallest_variant_price || smallest_variant_price === null) {
          smallest_variant_id = IndivVariant.id;
          smallest_variant_price = IndivVariant.price;
          break;
        }
      }
    }
    let mainHTML = `<div class="product-card-desktop">`;
    mainHTML += `<div class="product-images ${item.images.length === 1 ? "single-image" : ""}">`;
    item.images.forEach((image, index) => {
      mainHTML += `<a href="https://ringconcierge.com/products/${item.url}?variant=${variantID}&select-base=true" class="product-image-link">
              <div class="dropTheShop flair-integration"><div data-flair-product-badge data-product-id=${item.productId}></div></div>
              <img src="${image.src}" alt="${item.title}" class="product-image localStorage ${index === 1 ? "product-image-hover" : ""}">
          </a>`;
    });
    mainHTML += `</div>`;
    mainHTML += `<a href="https://ringconcierge.com/products/${item.url}?variant=${variantID}&select-base=true"><h3 class="product-title localStorage">${item.title}</h3></a>`;
    mainHTML += `<h5 class="product-price">`;
    if (item.uniquePrices.length > 1) {
      const sortedPrices = item.uniquePrices.sort((a, b) => a - b);
      mainHTML += `<span class="starting-at">Starting at <span class="money">${formatCurrency(sortedPrices[0])}</span></span>`;
      mainHTML += `<p class="showSalePriceOnSearch" id="${variantID}_${sectionId}_${variantSKU}" data-sale-price='${VariantMetaID.sale_price}' data-vip-price='${VariantMetaID.vip_price}' data-vvip-price='${VariantMetaID.vvip_price}' data-variant-id='${variantID}' data-variant-sku='${variantSKU}' data-section-id='${sectionId}' data-product-id=${productID} data-variant='${JSON.stringify(VariantJSon)}' data-variant-detail=${smallest_variant_price}></p>`;
    } else {
      mainHTML += `<span class="money">${formatCurrency(item.price)}</span>`;
      mainHTML += `<p class="showSalePriceOnSearch" id="${variantID}_${sectionId}_${variantSKU}" data-variant-id='${variantID}' data-sale-price='${VariantMetaID.sale_price}' data-vip-price='${VariantMetaID.vip_price}' data-vvip-price='${VariantMetaID.vvip_price}' data-variant-sku='${variantSKU}' data-section-id='${sectionId}' data-product-id=${productID} data-variant='${JSON.stringify(VariantJSon)}' data-variant-detail=${smallest_variant_price}></p>`;
    }
    mainHTML += `</h5>`;
    mainHTML += `<a href="https://ringconcierge.com/products/${item.url}?variant=${variantID}&select-base=true" class="select-button localStorage">Select</a>`;
    mainHTML += `</div>`;
    setTimeout(() => {
      if (typeof FlairApp !== 'undefined' && typeof FlairApp.refreshProductBadges === 'function') {
        FlairApp.refreshProductBadges();
      }
    }, 1200);
    return mainHTML;
  }
  // Generate HTML for product card (mobile with Flickity slider)
  function generateMobileProductCardHTML(item) {
    var VariantMetaID = item.variantmetafield
    var VariantJSon = item.variant
    var variantID = item.variant.id;
    var productID = item.productId;
    var variantSKU = item.variant.sku;
    var prodVariants = item.product;
    var smallest_variant_id = prodVariants[0].id;
    var smallest_variant_price = prodVariants[0].price;
    for (let i = 0; i < prodVariants.length; i++) {
      var IndivVariant = prodVariants[i];
      if (IndivVariant.inventory_quantity > 0 && IndivVariant.inventory_management != null && IndivVariant.option2 != "I don't know my size; send me a Ring Sizing Gauge!") {
        if (IndivVariant.price <= smallest_variant_price || smallest_variant_price === null) {
          smallest_variant_id = IndivVariant.id;
          smallest_variant_price = IndivVariant.price;
          break;
        }
      }
    }
    let mainHTML = `<div class="product-card-mobile">`;
    mainHTML += `<div class="product-images flickity-slider">`;
    item.images.forEach(image => {
      mainHTML += `<div class="carousel-cell">
              <a href="https://ringconcierge.com/products/${item.url}?variant=${variantID}&select-base=true" class="product-image-link">
              <div class="dropTheShop flair-integration"><div data-flair-product-badge data-product-id=${item.productId}></div></div>
              <img src="${image.src}" alt="${item.title}" class="product-image localStorage">
              </a>
          </div>`;
    });
    mainHTML += `</div>`;
    mainHTML += `<a href="https://ringconcierge.com/products/${item.url}?variant=${variantID}&select-base=true"><h3 class="product-title localStorage">${item.title}</h3></a>`;
    mainHTML += `<h5 class="product-price">`;
    if (item.uniquePrices.length > 1) {
      const sortedPrices = item.uniquePrices.sort((a, b) => a - b);
      mainHTML += `<span class="starting-at">Starting at <span class="money">${formatCurrency(sortedPrices[0])}</span></span>`;
      mainHTML += `<p class="showSalePriceOnSearch" id="${variantID}_${sectionId}_${variantSKU}" data-sale-price='${VariantMetaID.sale_price}' data-vip-price='${VariantMetaID.vip_price}' data-vvip-price='${VariantMetaID.vvip_price}' data-variant-id='${variantID}' data-variant-sku='${variantSKU}' data-section-id='${sectionId}' data-product-id=${productID} data-variant='${JSON.stringify(VariantJSon)}' data-variant-detail=${smallest_variant_price}></p>`;
    } else {
      mainHTML += `<span class="money">${formatCurrency(item.price)}</span>`;
      mainHTML += `<p class="showSalePriceOnSearch" id="${variantID}_${sectionId}_${variantSKU}" data-variant-id='${variantID}' data-sale-price='${VariantMetaID.sale_price}' data-vip-price='${VariantMetaID.vip_price}' data-vvip-price='${VariantMetaID.vvip_price}' data-variant-sku='${variantSKU}' data-section-id='${sectionId}' data-product-id=${productID} data-variant='${JSON.stringify(VariantJSon)}' data-variant-detail=${smallest_variant_price}></p>`;
    }
    mainHTML += `</h5>`;
    mainHTML += `<a href="https://ringconcierge.com/products/${item.url}?variant=${variantID}&select-base=true" class="select-button localStorage">Select</a>`;
    mainHTML += `</div>`;
    setTimeout(() => {
      if (typeof FlairApp !== 'undefined' && typeof FlairApp.refreshProductBadges === 'function') {
        FlairApp.refreshProductBadges();
      }
    }, 1200);
    return mainHTML;
  }
  // Display matching variants
  function displayMatchingVariants(matchingVariants) {
    if ($(".charm-product-list").children().length > 0) $(".charm-product-list").empty();
    if ($(".charm-product-list-mobile").children().length > 0) $(".charm-product-list-mobile").empty();
    matchingVariants.forEach(item => {
        if (item.variant.available === true ) {
      const desktopProductCardHTML = generateDesktopProductCardHTML(item);
      const mobileProductCardHTML = generateMobileProductCardHTML(item);
      if (window.innerWidth <= 768) {
        $(".charm-product-list-mobile").append(mobileProductCardHTML);
      } else {
        $(".charm-product-list").append(desktopProductCardHTML);
      }
    }
    });
    initializeFlickitymob();
    showSalePriceOnSearchBar();
  }
  // Initialize Flickity slider for mobile
  function initializeFlickitymob() {
    $('.flickity-slider').flickity({
      cellAlign: 'left',
      prevNextButtons: false,
      contain: true,
      wrapAround: true,
      lazyLoad: true,
      pageDots: false
    });
  }
  // Initialize price slider
  function initializeSlider() {
    const inputMin = document.getElementById("input-min");
    const inputMax = document.getElementById("input-max");
    cbCharmSliderPrice = document.getElementById("sliderId");
    noUiSlider.create(cbCharmSliderPrice, {
      start: [0, 2000],
      connect: true,
      range: {
        min: 0,
        max: 2000,
      },
      format: {
        to: value => Math.round(value),
        from: value => Math.round(value),
      },
    });
    const initialValues = cbCharmSliderPrice.noUiSlider.get();
    inputMin.value = Math.round(initialValues[0]);
    inputMax.value = Math.round(initialValues[1]);
    cbCharmSliderPrice.noUiSlider.on("update", function(values, handle) {
      if (handle) {
        inputMax.value = values[handle];
        selectedMaxPrice = parseFloat(values[handle]);
      } else {
        inputMin.value = values[handle];
        selectedMinPrice = parseFloat(values[handle]);
      }
      getVariantsColor(allProducts, selectedColor, selectedType);
    });
    inputMin.addEventListener("change", function() {
      const value = parseFloat(this.value);
      if (!isNaN(value)) {
        cbCharmSliderPrice.noUiSlider.set([value, null]);
      }
    });
    inputMax.addEventListener("change", function() {
      const value = parseFloat(this.value);
      if (!isNaN(value)) {
        cbCharmSliderPrice.noUiSlider.set([null, value]);
      }
    });
  }
  let resizeTimeout;
  var windowWidth = $(window).width();
  // Get variants based on selected color and type
  function getVariantsColor(allProducts, selectedColor, selectedType, selectedSortValue) {
    if (!selectedColor || !selectedType) {
      console.error("Selected color or type is undefined.");
      return;
    }
    const selectedColors = selectedColor.split(" / ").map(color => color.toLowerCase());
    let matchingVariants = [];
    allProducts.forEach(product => {
      let foundVariant = null;
      for (let variant of product.variants) {
        const silver = [variant.option1, variant.option2, variant.option3].map(option => option?.toLowerCase()).includes("silver") ? "silver" : "";
        const combinedOptions = [variant.option1, variant.option2, variant.option3, silver].filter(Boolean).join(" ").toLowerCase();
        const colorMatch = selectedColors.some(color => combinedOptions.includes(color));
        const variantPrice = variant.price / 100;
        if (colorMatch && product.type.toLowerCase() === selectedType.toLowerCase() && variantPrice >= selectedMinPrice && variantPrice <= selectedMaxPrice) {
          const filteredImages = filterImagesByColor(product.media, selectedColors);
          const variantMetafields = product.variantMetafields[variant.id] || {};
          // console.log(product.variantMetafields[variant.id],
          foundVariant = {
            productId: product.id,
            variant,
            variantmetafield : variantMetafields,
            images: filteredImages,
            title: product.title,
            price: variant.price,
            uniquePrices: getUniquePrices(product.variants),
            url: product.handle,
            product: product.variants
          };
          break;
        }
      }
      if (foundVariant) {
        matchingVariants.push(foundVariant);
      }
    });
    if (selectedSortValue === "ascending") {
      matchingVariants.sort((a, b) => a.price - b.price);
    } else if (selectedSortValue === "descending") {
      matchingVariants.sort((a, b) => b.price - a.price);
    }
    if (matchingVariants.length > 0) {
      displayMatchingVariants(matchingVariants);
      $(window).resize(function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          if ($(window).width() != windowWidth) {
            displayMatchingVariants(matchingVariants);
            windowWidth = $(window).width();
          }
        }, 200);
      });
      $(".managebox-message-desk , .managebox-message-mobile").remove();
    } else {
      $(".charm-product-list, .charm-product-list-mobile").empty();
      if ($(".managebox-message-desk , .managebox-message-mobile").length < 1) {
        $(".charm-product-list").after(`
                  <div class="managebox-message-desk">
                      <h3 class="no-results-message">We couldn't find any products with the selected filters. Try refining your search or resetting the filters.</h3>
                      <button id="reset-filters-btn">Reset All Filters</button>
                  </div>
              `);
        $(".charm-product-list-mobile").after(`
                  <div class="managebox-message-mobile">
                      <h3 class="no-results-message">We couldn't find any products with the selected filters. Try refining your search or resetting the filters.</h3>
                      <button id="reset-filters-btn">Reset All Filters</button>
                  </div>
              `);
        $("#reset-filters-btn").on("click", resetAllFilters);
      }
    }
  }
  // Reset all filters
  function resetAllFilters() {
    selectedColor = $(".color-option").first().data("color");
    selectedType = $(".product-type").first().data("type");
    selectedMinPrice = 0;
    selectedMaxPrice = 2000;
    $(".color-option").removeClass("selected").first().addClass("selected");
    $(".product-type").removeClass("selected").first().addClass("selected");
    if (cbCharmSliderPrice && cbCharmSliderPrice.noUiSlider) {
      cbCharmSliderPrice.noUiSlider.set([selectedMinPrice, selectedMaxPrice]);
    }
    getVariantsColor(allProducts, selectedColor, selectedType);
  }
  // Initialize the application
  function initializeApp() {
    if (pageType === 'product') return;
    $('.pdp-cb-banner').removeClass('hide')
    setupColorOptions();
    setupProductTypeOptions();
    loadInitialSelections();
    getVariantsColor(allProducts, selectedColor, selectedType);
    initializeSlider();
    logOptionValueAndHideCard();
    targetPosition = $('.cb-base').offset().top - 100;
    $(window).scrollTop(targetPosition);
    document.onreadystatechange = function() {
    enableScroll();
      };
  }
  initializeApp();

  function getLocalStorageData(key) {
    const data = localStorage.getItem(key);
    if (!data || ['null', 'undefined', '{}'].includes(data)) {
      return null;
    }
    return JSON.parse(data);
  }
  // First Product Selection JS Selected Base 
  function handleVisibility() {
    const urlParams = new URLSearchParams(window.location.search);
    const selectBase = urlParams.get('select-base');
    const selectCharm = urlParams.get('selectcharm');
    const selectAnotherCharm = urlParams.get('addanotherPDPcharm');
    const cbpreCart = urlParams.get('charmPreCart');
    const editBase = urlParams.get('editbase');
    const editCharm = urlParams.get('editcharm');
    if (pageType === 'product' && selectBase !== 'true' && selectCharm !== 'true' && selectAnotherCharm !== 'true' && cbpreCart !== 'true') {
      $(".cb-rc-sets-section").addClass("hide");
    }
    if (pageType === 'product' && cbpreCart === 'true') {
      StickyHeader()
      $(".pre-cart-cb, .pre-cart-details").removeClass("hide");
      $('.pdp-cb-banner, .charm-breadcrumb').removeClass('hide')
      $(".Product__InfoWrapper.pdp-info-detail-wrapper").hide();
      $(".pdp-products-carousel-cb").addClass("hide");
      setTimeout(() => {
        $("#yotpo-widget-three-reviews").remove();
      }, 5000);
      targetPosition = $('.pre-cart-cb').offset().top - 100;
      $(window).scrollTop(targetPosition);
        document.onreadystatechange = function() {
        enableScroll();
      };
    }
    // Handle the 'select-base' parameter visibility
    if (selectBase === 'true' && pageType === 'product') {
      // $("#charm-product-price").append(`<span class="money">${formatCurrency(currentVariantJson.price)}</span>`);
      var dataPrice = currentVariantJson.price; 
      $(".right-checked").attr('data-price', dataPrice);
      $(".base-pdp-acc").removeClass("hide");
      $('.pdp-cb-banner, .charm-breadcrumb').removeClass('hide')
      $(".product-detail-slideshow-wrapper").addClass('parent-cb-base');
      if (editBase === 'true') {
        if (currentVariantJson.available === true) {
           if(grabTeaserBtnText !== ''){
            $(".buttons--wrapper").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth" disabled="disabled">${grabTeaserBtnText}</button>`);
          } else {
          $(".buttons--wrapper").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth charmAddToCart" id="editbase">SELECT BASE</button>`);
          }
        } else {
          $(".buttons--wrapper").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth charmAddToCart" disabled="disabled" id="editbase">Sold Out</button>`);
        }
        editJSBase()
      } else {
        if (currentVariantJson.available === true) {
           if(grabTeaserBtnText !== ''){
            $(".buttons--wrapper").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth" disabled="disabled">${grabTeaserBtnText}</button>`);
          } else {
          $(".buttons--wrapper").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth charmAddToCart" id="addbase">NEXT STEP: ADD CHARMS</button>`);
          }
        } else {
          $(".buttons--wrapper").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth charmAddToCart" disabled="disabled" id="addbase">Sold Out</button>`);
        }
      }
      $(".mejuri-card, .pdp-products-carousel-cb").addClass("hide");
      $(".three-list").removeClass("hide");
      setTimeout(() => {
        $(".custom_size_meta_drop_down").addClass("hide");
      }, 2500);
      AddParamJSBase();
      $(".Product__Info").prepend(`
      <a href="https://ringconcierge.com/collections/select-your-base" class="js-cb-close">
          <img src="https://cdn.shopify.com/s/files/1/1359/2701/files/button-close.svg?v=1722846864" alt="" />
      </a>
  `);
      targetPosition = $('.base-pdp-acc').offset().top - 100;
    $(window).scrollTop(targetPosition);
    document.onreadystatechange = function() {
    enableScroll();
      };
    }
    if (selectCharm === 'true' && pageType === 'product') {
      $(".charm-pdp-acc").removeClass("hide");
      $('.pdp-cb-banner, .charm-breadcrumb').removeClass('hide')
      $(".product-detail-slideshow-wrapper").addClass("parent-cb-base");
      if (editCharm === 'true') {
        if (currentVariantJson.available == true) {
           if(grabTeaserBtnText !== ''){
            $(".buttons--wrapper").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth" disabled="disabled">${grabTeaserBtnText}</button>`);
          } else {
          $(".buttons--wrapper").addClass("white-cst-btn").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth charmAddToCart" id="editCharm">SELECT CHARM </button>`);
          }
        } else {
          $(".buttons--wrapper").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth charmAddToCart" disabled="disabled" id="editCharm">Sold Out</button>`);
        }
        editJSCharm()
      } else {
        if (currentVariantJson.available == true) {
          if(grabTeaserBtnText !== ''){
            $(".buttons--wrapper").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth" disabled="disabled">${grabTeaserBtnText}</button>`);
          } else {
            $(".buttons--wrapper").addClass("white-cst-btn").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth charmAddToCart" id="addCharm"> ADD CHARM + ${formatCurrency(currentVariantJson.price)}</button>`);
          }
        } else {
          $(".buttons--wrapper").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth charmAddToCart" disabled="disabled" id="addCharm">Sold Out</button>`);
        }
      }
      $(".mejuri-card, .pdp-usp-icons--wrapper, .pdp-products-carousel-cb").addClass("hide");
      setTimeout(() => {
        $(".custom_size_meta_drop_down").addClass("hide");
      }, 2500);
      AddParamJSCharm();
      $(".Product__Info").prepend(`
          <a href="https://ringconcierge.com/collections/select-your-charm" class="js-cb-close">
          <img src="https://cdn.shopify.com/s/files/1/1359/2701/files/button-close.svg?v=1722846864" alt="" />
          </a>
      `);
      targetPosition = $('.charm-pdp-acc').offset().top - 100;
      $(window).scrollTop(targetPosition);
      document.onreadystatechange = function() {
      enableScroll();
        };
    }
    if (selectAnotherCharm === 'true' && pageType === 'product') {
      $(".charm-pdp-acc").removeClass("hide");
      $('.pdp-cb-banner, .charm-breadcrumb').removeClass('hide')
      $(".product-detail-slideshow-wrapper").addClass("parent-cb-base");
      if (currentVariantJson.available == true) {
        if(grabTeaserBtnText !== ''){
            $(".buttons--wrapper").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth" disabled="disabled">${grabTeaserBtnText}</button>`);
          } else {
        $(".buttons--wrapper").addClass("white-cst-btn").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth charmAddToCart" id="selectAnotherCharm"> ADD ANOTHER CHARM + ${formatCurrency(currentVariantJson.price)}</button>`);
          }
      } else {
        $(".buttons--wrapper").find(".BlackWhiteCustomizer").replaceWith(`<button class="btn btn-dark btn-fullwidth charmAddToCart" disabled="disabled" id="selectAnotherCharm">Sold Out</button>`);
      }
      $(".mejuri-card, .pdp-usp-icons--wrapper, .pdp-products-carousel-cb").addClass("hide");
      setTimeout(() => {
        $(".custom_size_meta_drop_down").addClass("hide");
      }, 2500);
      AddParamJSAnotherCharm()
      $(".Product__Info").prepend(`
          <a href="https://ringconcierge.com/collections/select-your-charm" class="js-cb-close">
          <img src="https://cdn.shopify.com/s/files/1/1359/2701/files/button-close.svg?v=1722846864" alt="" />
          </a>
      `);
      targetPosition = $('.charm-pdp-acc').offset().top - 100;
      $(window).scrollTop(targetPosition);
          document.onreadystatechange = function() {
          enableScroll();
            };
    }
  }
  // Function to add 'select-base' parameter on click
  function AddParamJSBase() {
    $(".HorizontalList--spacingTight, .Popover__ValueList").on('click', function() {
      setTimeout(() => {
        // $("#charm-product-price").empty();
        // $("right-checked").attr(data-price,"")
        // $("#charm-product-price").append(`<span class="money">${formatCurrency(currentVariantJson.price)}</span>`);
        // $("#charm-product-price").find("span.money").addClass("strikeThrough");
        // $('#charm-product-price').append('<span class="charm-color-sale" style="color:' + showPercentageOffColorGlobal + '">$' + formattedSalePrice + '</span>');

        const dataPrice = currentVariantJson.price;
        $(".right-checked").attr('data-price', dataPrice);
        if (currentVariantJson.available !== true) {
          $("#addbase").text("Sold Out").attr("disabled", "disabled");
        } else {
          $("#addbase").text("NEXT STEP: ADD CHARMS").removeAttr("disabled", "disabled");
        }
        let newUrl = new URL(window.location.href);
        newUrl.searchParams.set('select-base', 'true');
        window.history.pushState({}, '', newUrl);
      }, 50);
    });
  }

  function editJSBase() {
    $(".HorizontalList--spacingTight, .Popover__ValueList").on('click', function() {
      setTimeout(() => {
        if (currentVariantJson.available !== true) {
          $("#editbase").text("Sold Out").attr("disabled", "disabled");
        } else {
          $("#editbase").text("SELECT BASE").removeAttr("disabled", "disabled");
        }
        let newUrl = new URL(window.location.href);
        newUrl.searchParams.set('select-base', 'true');
        newUrl.searchParams.set('editbase', 'true');
        window.history.pushState({}, '', newUrl);
      }, 50);
    });
  }

  function editJSCharm() {
    $(".HorizontalList--spacingTight, .Popover__ValueList, #engravablesInputsWrapperSlider").on('click', function() {
      setTimeout(() => {
        if (currentVariantJson.available !== true) {
          $("#editbase").text("Sold Out").attr("disabled", "disabled");
        } else {
          $("#editbase").text("SELECT CHARM").removeAttr("disabled", "disabled");
        }
        let newUrl = new URL(window.location.href);
        newUrl.searchParams.set("selectcharm", "true");
        newUrl.searchParams.set('editcharm', 'true');
        window.history.pushState({}, '', newUrl);
      }, 50);
    });
  }
  function AddParamJSCharm() {
    let UpdatedPrice = "";
    $(".HorizontalList--spacingTight, .Popover__ValueList, #engravablesInputsWrapperSlider").on("click", function() {
      setTimeout(() => {
        if ($('#engravablesInputsWrapper').is(":checked")) {
          if (showSalePriceGlobal || showVIPPriceGlobal || showVVIPPriceGlobal || showVIPPrivateSale || showVVIPPrivateSale) {
            UpdatedPrice = $('#appendSale').text().trim();
            if (!UpdatedPrice) {
              UpdatedPrice = $('#appendReg').text().trim();
              if (!UpdatedPrice) {
                UpdatedPrice = formatCurrency(currentVariantJson.price);
              }
            }
          } else {
            UpdatedPrice = $('#appendReg').text().trim();
            if (!UpdatedPrice) {
              UpdatedPrice = formatCurrency(currentVariantJson.price);
            }
          }
        } else {
          UpdatedPrice = $('#appendSale').text().trim();
          if (!UpdatedPrice) {
            UpdatedPrice = $('#appendReg').text().trim();
            if (!UpdatedPrice) {
              UpdatedPrice = formatCurrency(currentVariantJson.price);
            }
          }
        }
        if (currentVariantJson.available !== true) {
          $("#addCharm").text("Sold Out").attr("disabled", "disabled");
        } else {
          $("#addCharm").text(`ADD CHARM + ${UpdatedPrice}`).removeAttr("disabled", "disabled");
        }
        let newUrl = new URL(window.location.href);
        newUrl.searchParams.set("selectcharm", "true");
        window.history.pushState({}, "", newUrl);
      }, 50);
    });
  }

  function AddParamJSAnotherCharm() {
    let UpdatedPrice = "";
    $(".HorizontalList--spacingTight, .Popover__ValueList, #engravablesInputsWrapperSlider").on("click", function() {
      setTimeout(() => {
        if ($('#engravablesInputsWrapper').is(":checked")) {
          if (showSalePriceGlobal || showVIPPriceGlobal || showVVIPPriceGlobal || showVIPPrivateSale || showVVIPPrivateSale) {
            UpdatedPrice = $('#appendSale').text().trim();
            if (!UpdatedPrice) {
              UpdatedPrice = $('#appendReg').text().trim();
              if (!UpdatedPrice) {
                UpdatedPrice = formatCurrency(currentVariantJson.price);
              }
            }
          } else {
            UpdatedPrice = $('#appendReg').text().trim();
            if (!UpdatedPrice) {
              UpdatedPrice = formatCurrency(currentVariantJson.price);
            }
          }
        } else {
          UpdatedPrice = $('#appendSale').text().trim();
          if (!UpdatedPrice) {
            UpdatedPrice = $('#appendReg').text().trim();
            if (!UpdatedPrice) {
              UpdatedPrice = formatCurrency(currentVariantJson.price);
            }
          }
        }
        if (currentVariantJson.available !== true) {
          $("#selectAnotherCharm").text("Sold Out").attr("disabled", "disabled");
        } else {
          $("#selectAnotherCharm").text(`ADD ANOTHER CHARM + ${UpdatedPrice}`).removeAttr("disabled", "disabled");
        }
        let newUrl = new URL(window.location.href);
        newUrl.searchParams.set("addanotherPDPcharm", "true");
        window.history.pushState({}, "", newUrl);
      }, 50);
    });
  }

  function StickyHeader() {
    const allProductStoredData = getLocalStorageData('cbBundleData');
    if (!allProductStoredData) return;
    const cartItemsFilter = document.querySelector('.charm-base-selection');
    let productListHtml = '';
    let charmProducts = allProductStoredData.charms;
    let charmCount = charmProducts.length;
    charmProducts.forEach((charm, index) => {
      if (charm) {
        const productType = 'charm'; 
        const storedUniqueKey = charm.properties._cb_UniqueKey;
        productListHtml += generateProductHTML(charm, productType, storedUniqueKey, charmCount === 1);
      }
    });
    // Append "ADD ANOTHER CHARM" button at the end
    productListHtml += `<a href="https://ringconcierge.com/collections/select-your-charm?addanothercharm=true" class="add-another-charm"> + ADD ANOTHER CHARM</a>`;
    cartItemsFilter.innerHTML = productListHtml;
    document.querySelectorAll('.removes-filter').forEach(button => {
      const productElement = button.closest('.items-filter');
      const productId = productElement.getAttribute('data-product-id');
      const storedUniqueKey = productElement.getAttribute('data-uniquekey');
      button.addEventListener('click', function() {
        removeProduct(productId, 'charm', storedUniqueKey);
        productElement.remove();
        window.location.reload();
      });
    });
  }
  // Utility function to generate the HTML for a charm product
  function generateProductHTML(product, productType, storedUniqueKey, isLastCharm) {
    const isBase = productType === 'base';
    const saleData = product.cbBundleSale || {};
    const salePrice = saleData.salePrice ? parseFloat(saleData.salePrice) : null;
    const regularPrice = saleData.regularPrice ? parseFloat(saleData.regularPrice) : parseFloat(product.price);
    const compareAt = saleData.compareAt ? parseFloat(saleData.compareAt) : null;


    let priceHtml = '';  // Initialize variable for price HTML
    const percentOffHtml = saleData.percentOff ? `<span class="discount" style="color:${showPercentageOffColorGlobal};">${saleData.percentOff}% IOff</span>` : '';
    const formatPrice = amount => `${amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;

    // Logic for displaying price based on availability of salePrice, regularPrice, and compareAt
    if (salePrice && compareAt) {
        // Display both sale price and compare at price
        priceHtml = `
            <span class="strikethrough">$${formatPrice(compareAt)}</span>
            ${percentOffHtml}
            <span style="color:${showPercentageOffColorGlobal};">${formatPrice(salePrice)}</span>
        `;
    } else if (salePrice) {
        // Display sale price with regular price strikethrough
        priceHtml = `
            <span class="strikethrough">$${formatPrice(regularPrice)}</span>
            ${percentOffHtml}
            <span class="sale-price-color" style="color:${showPercentageOffColorGlobal};">$${formatPrice(salePrice)}</span>
        `;
    } else if (regularPrice) {
        // Display only regular price if no sale or compare at price is available
        priceHtml = `<span>$${formatPrice(regularPrice)}</span>`;
    }

    return `
    <div class="items-filter" data-product-id="${product.productID}" data-product-type="${productType}" data-uniquekey="${storedUniqueKey}">
        <img src="${product.image[0].src}" alt="${product.name}" class="items-filter-img" />
        <div class="items-filter-details">
            <p>${product.name}</p>
             ${priceHtml}
        </div>
        <button class="removes-filter" ${isLastCharm ? 'disabled class="disabled-button"' : ''}>
            <img src="https://cdn.shopify.com/s/files/1/1359/2701/files/ic-close.svg?v=1695033714" />
        </button>
    </div>`;
  }
  // Remove charm product from localStorage and update cbBundleData
  function removeProduct(productId, productType, storedUniqueKey) {
    let bundleData = getLocalStorageData('cbBundleData');
    if (!bundleData) return;
    // Update charms by filtering out the one that matches productId and storedUniqueKey
    if (productType === 'charm') {
      bundleData.charms = bundleData.charms.filter(charm => charm.productID.toString() !== productId || charm.properties._cb_UniqueKey !== storedUniqueKey);
    }
    localStorage.setItem('cbBundleData', JSON.stringify(bundleData));
    StickyHeader();
  }
  handleVisibility();

  function getfirstSelectedVariantdetails() {
    const urlParams = new URLSearchParams(window.location.search);
    var selectBase = urlParams.get('select-base');
    if (pageType === 'product' && selectBase === 'true') {} else {
      const cbBundleData = getLocalStorageData('cbBundleData');
      const saveProductTitle = cbBundleData?.base?.name;
      const saveProductPrice = cbBundleData?.base?.price;
      const compareAt = cbBundleData?.base?.cbBundleSale?.compareAt;
      const salePrice = cbBundleData?.base?.cbBundleSale?.salePrice;
      const regularPrice = cbBundleData?.base?.cbBundleSale?.regularPrice;
      const iconPlaceholder = $('.crm-accordion-header .icon-placeholder');
      const formatPrice = amount => {
    // Ensure amount is a number, parse if it's a string
    if (typeof amount !== 'number') {
        amount = parseFloat(amount);
    }

    // If amount is still not a valid number, return a default value or handle the error
    if (isNaN(amount)) {
        return '$0.00'; // or return '' to show nothing
    }

    // Format the amount as currency
    return `$${amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    };
      // Remove any previous sibling elements
      iconPlaceholder.next().remove();
      let span = $('<span></span>');
      // Price logic
      if (compareAt) {
        span.html(`${saveProductTitle} Was: <span class="strikethrough was-price">${formatPrice(compareAt)}</span> <span class="regular-price"style="color:${salePriceColorGlobal}">${formatPrice(regularPrice)}</span>`);
      } else if (salePrice) {
        span.html(`${saveProductTitle} <span class="regular-price">${formatPrice(regularPrice)}</span> <span class="sale-price" style="color:${salePriceColorGlobal}">${formatPrice(salePrice)}</span> `);
        span.find('.regular-price').addClass('strikethrough');
      } else {
        span.text(`${saveProductTitle} ${formatPrice(regularPrice)}`);
      }
      iconPlaceholder.after(span);
    }
  }
  if (typeof getfirstSelectedVariantdetails === 'function' && pageType === 'product') {
    getfirstSelectedVariantdetails();
  }

  function getTransformedProperties() {
    var formData = $('form[action="/cart/add"]').serializeArray();
    var transformedProperties = formData.filter(function(item) {
      return item.name.startsWith('properties[');
    }).reduce(function(acc, item) {
      var key = item.name.replace(/^properties\[(.*)\]$/, '$1');
      acc[key] = item.value;
      return acc;
    }, {});
    return transformedProperties;
  }

  function getFirstVariant() {
    var cbBundleData = getLocalStorageData('cbBundleData') || {};
    if (cbBundleData) {
      localStorage.removeItem('cbBundleData');
    }
// Retrieve and process prices as integer values
let percentOff = parseFloat($('#percentOff').text().replace(/[$,]/g, '').trim()) || 0;
let compareAt = parseFloat($('#appendCompareAt').text().replace(/[$,]/g, '').trim()) || 0;
let salePrice = parseFloat($('#appendSale').text().replace(/[$,]/g, '').trim()) || 0;
let regularPrice = parseFloat($('#appendReg').text().replace(/[$,]/g, '').trim()) || 0;
    var properties = getTransformedProperties();
    var randomStringInlay = (Math.random() + 1).toString(36).substring(2);
    properties._cb_UniqueKey = `charm_${randomStringInlay}-product_${currentProductJson.id}-variant-${currentVariantJson.id}`;
    properties._associated_unique_key = randomStringInlay;
    const engravingRequired = properties["_engraving_required"] === "Yes";
    let updatedPrice = currentVariantJson.price;
    // Add $30 to the price if engraving is required
    if (engravingRequired) {
      updatedPrice += 3000;
    }
    var cbBundleData = {
      base: {
        name: currentProductJson.title,
        productID: currentProductJson.id,
        variantID: currentVariantJson.id,
        dynamicUrl: `${currentProductJson.handle}?variant=${currentVariantJson.id}`,
        productOptions: currentProductJson.options,
        variantOptions: currentVariantJson.options,
        price: updatedPrice,
        image: currentProductJson.media,
        properties: properties,
        cbBundleSale: {
          percentOff: percentOff,
          compareAt: compareAt,
          salePrice: salePrice,
          regularPrice: regularPrice
        }
      },
      charms: []
    };
    localStorage.setItem('cbBundleData', JSON.stringify(cbBundleData));
    findRequiredFields(function(status) {
      if (status) {
        window.location.href = "https://ringconcierge.com/collections/select-your-charm";
      }
    });
  }
  $('#addbase').on('click', function(event) {
    event.preventDefault();
    getFirstVariant();
  });
  $('#addbase').on('keypress', function(event) {
    event.preventDefault();
    if (event.key === 'Enter') {
      getFirstVariant();
    }
  });

  function editBaseVariant() {
 // Retrieve and process prices as integer values
let percentOff = parseFloat($('#percentOff').text().replace(/[$,]/g, '').trim()) || 0;
let compareAt = parseFloat($('#appendCompareAt').text().replace(/[$,]/g, '').trim()) || 0;
let salePrice = parseFloat($('#appendSale').text().replace(/[$,]/g, '').trim()) || 0;
let regularPrice = parseFloat($('#appendReg').text().replace(/[$,]/g, '').trim()) || 0;

    var cbBundleData = getLocalStorageData('cbBundleData') || {};
    var properties = getTransformedProperties();
    var randomStringInlay = (Math.random() + 1).toString(36).substring(2);
    properties._cb_UniqueKey = `charm_${randomStringInlay}-product_${currentProductJson.id}-variant-${currentVariantJson.id}`;
    properties._associated_unique_key = randomStringInlay;
    const engravingRequired = properties["_engraving_required"] === "Yes";
    let updatedPrice = currentVariantJson.price;
    // Add $30 to the price if engraving is required
    if (engravingRequired) {
      updatedPrice += 3000;
    }
    cbBundleData.base = {
      name: currentProductJson.title,
      productID: currentProductJson.id,
      variantID: currentVariantJson.id,
      dynamicUrl: `${currentProductJson.handle}?variant=${currentVariantJson.id}`,
      productOptions: currentProductJson.options,
      variantOptions: currentVariantJson.options,
      price: updatedPrice,
      image: currentProductJson.media,
      properties: properties,
      cbBundleSale: {
        percentOff: percentOff,
        compareAt: compareAt,
        salePrice: salePrice,
        regularPrice: regularPrice
      }
    };
    localStorage.setItem('cbBundleData', JSON.stringify(cbBundleData));
    const editbaseurl = cbBundleData.base.dynamicUrl;
    findRequiredFields(function(status) {
      if (status) {
        window.location.href = `https://ringconcierge.com/products/${editbaseurl}&charmPreCart=true`;
      }
    });
  }
  $('#editbase').on('click', function(event) {
    event.preventDefault();
    editBaseVariant();
  });
  $('#editbase').on('keypress', function(event) {
    event.preventDefault();
    if (event.key === 'Enter') {
      editBaseVariant();
    }
  });

  function getSecondVariant() {
    var cbBundleData = getLocalStorageData('cbBundleData') || {};
    if (!cbBundleData.base) {
      window.location.href = "https://ringconcierge.com/collections/select-your-base";
      return;
    }
    var properties = getTransformedProperties();
    var randomStringInlay = (Math.random() + 1).toString(36).substring(2);
    properties._cb_UniqueKey = `charm_${randomStringInlay}-product_${currentProductJson.id}-variant-${currentVariantJson.id}`;
    properties._associated_unique_key = randomStringInlay;
    const engravingRequired = properties["_engraving_required"] === "Yes";
    let updatedPrice = currentVariantJson.price;
  // Retrieve and process prices as integer values
let percentOff = parseFloat($('#percentOff').text().replace(/[$,]/g, '').trim()) || 0;
let compareAt = parseFloat($('#appendCompareAt').text().replace(/[$,]/g, '').trim()) || 0;
let salePrice = parseFloat($('#appendSale').text().replace(/[$,]/g, '').trim()) || 0;
let regularPrice = parseFloat($('#appendReg').text().replace(/[$,]/g, '').trim()) || 0;

    // Add $30 to the price if engraving is required
    if (engravingRequired) {
      updatedPrice += 3000;
    }
    cbBundleData.charms.push({
      name: currentProductJson.title,
      productID: currentProductJson.id,
      variantID: currentVariantJson.id,
      dynamicUrl: `${currentProductJson.handle}?variant=${currentVariantJson.id}`,
      productOptions: currentProductJson.options,
      variantOptions: currentVariantJson.options,
      price: updatedPrice,
      image: currentProductJson.media,
      properties: properties,
      cbBundleSale: {
        percentOff: percentOff,
        compareAt: compareAt,
        salePrice: salePrice,
        regularPrice: regularPrice
      }
    });
    localStorage.setItem('cbBundleData', JSON.stringify(cbBundleData));
    findRequiredFields(function(status) {
      if (status) {
        window.location.href = "https://ringconcierge.com/collections/select-your-charm?addanothercharm=true";
      }
    });
  }
  $('#addCharm').on('click', function(event) {
    event.preventDefault();
    getSecondVariant();
  });
  $('#addCharm').on('keypress', function(event) {
    event.preventDefault();
    if (event.key === 'Enter') {
      getSecondVariant();
    }
  });

  function getThirdVariant() {
    var cbBundleData = getLocalStorageData('cbBundleData') || {};
    if (!cbBundleData.base) {
      console.warn('Base product not selected. Redirecting...');
      window.location.href = "https://ringconcierge.com/collections/select-your-base";
      return;
    }
    var properties = getTransformedProperties();
    var randomStringInlay = (Math.random() + 1).toString(36).substring(2);
    properties._cb_UniqueKey = `charm_${randomStringInlay}-product_${currentProductJson.id}-variant-${currentVariantJson.id}`;
    properties._associated_unique_key = randomStringInlay;
    const engravingRequired = properties["_engraving_required"] === "Yes";
    let updatedPrice = currentVariantJson.price;
  // Retrieve and process prices as integer values
let percentOff = parseFloat($('#percentOff').text().replace(/[$,]/g, '').trim()) || 0;
let compareAt = parseFloat($('#appendCompareAt').text().replace(/[$,]/g, '').trim()) || 0;
let salePrice = parseFloat($('#appendSale').text().replace(/[$,]/g, '').trim()) || 0;
let regularPrice = parseFloat($('#appendReg').text().replace(/[$,]/g, '').trim()) || 0;

    // Add $30 to the price if engraving is required
    if (engravingRequired) {
      updatedPrice += 3000;
    }
    var newCharm = {
      name: currentProductJson.title,
      productID: currentProductJson.id,
      variantID: currentVariantJson.id,
      dynamicUrl: `${currentProductJson.handle}?variant=${currentVariantJson.id}`,
      price: updatedPrice,
      image: currentProductJson.media,
      productOptions: currentProductJson.options,
      variantOptions: currentVariantJson.options,
      properties: properties,
      cbBundleSale: {
        percentOff: percentOff,
        compareAt: compareAt,
        salePrice: salePrice,
        regularPrice: regularPrice
      }
    };
    cbBundleData.charms.push(newCharm);
    localStorage.setItem('cbBundleData', JSON.stringify(cbBundleData));
    findRequiredFields(function(status) {
      if (status) {
        window.location.href = "https://ringconcierge.com/collections/select-your-charm?addanothercharm=true";
      }
    });
  }
  $('#selectAnotherCharm').on('click', function(event) {
    event.preventDefault();
    getThirdVariant();
  });
  $('#selectAnotherCharm').on('keypress', function(event) {
    event.preventDefault();
    if (event.key === 'Enter') {
      getThirdVariant();
    }
  });

  function editCharmVariant() {
    var cbBundleData = getLocalStorageData('cbBundleData') || {};
    var selectedCharm = getLocalStorageData('selectedCharm') || {};
    const editCharmDatakey = selectedCharm.properties._cb_UniqueKey;
    const charmIndex = cbBundleData.charms.findIndex(charm => charm.properties._cb_UniqueKey === editCharmDatakey);
    if (charmIndex !== -1) {
      var properties = getTransformedProperties();
      var randomStringInlay = (Math.random() + 1).toString(36).substring(2);
      properties._cb_UniqueKey = `charm_${randomStringInlay}-product_${currentProductJson.id}-variant-${currentVariantJson.id}`;
      properties._associated_unique_key = randomStringInlay;
      const engravingRequired = properties["_engraving_required"] === "Yes";
      let updatedPrice = currentVariantJson.price;
// Retrieve and process prices as integer values
let percentOff = parseFloat($('#percentOff').text().replace(/[$,]/g, '').trim()) || 0;
let compareAt = parseFloat($('#appendCompareAt').text().replace(/[$,]/g, '').trim()) || 0;
let salePrice = parseFloat($('#appendSale').text().replace(/[$,]/g, '').trim()) || 0;
let regularPrice = parseFloat($('#appendReg').text().replace(/[$,]/g, '').trim()) || 0;

      // Add $30 to the price if engraving is required
      if (engravingRequired) {
        updatedPrice += 3000;
      }
      cbBundleData.charms[charmIndex] = {
        name: currentProductJson.title,
        productID: currentProductJson.id,
        variantID: currentVariantJson.id,
        dynamicUrl: `${currentProductJson.handle}?variant=${currentVariantJson.id}`,
        productOptions: currentProductJson.options,
        variantOptions: currentVariantJson.options,
        price: updatedPrice,
        image: currentProductJson.media,
        properties: properties,
        cbBundleSale: {
          percentOff: percentOff,
          compareAt: compareAt,
          salePrice: salePrice,
          regularPrice: regularPrice
        }
      };
      localStorage.setItem('cbBundleData', JSON.stringify(cbBundleData));
      const editbaseurl = cbBundleData.base.dynamicUrl;
      findRequiredFields(function(status) {
        if (status) {
          localStorage.removeItem('selectedCharm');
          window.location.href = `https://ringconcierge.com/products/${editbaseurl}&charmPreCart=true`;
        }
      });
    }
  }
  $('#editCharm').on('click', function(event) {
    event.preventDefault();
    editCharmVariant()
  });
  $('#addCheditCharmarm').on('keypress', function(event) {
    event.preventDefault();
    if (event.key === 'Enter') {
      editCharmVariant()
    }
  });
});